import { Box, Flex, Stack, Text, VStack } from '@chakra-ui/react';
import { gridConfig } from '@time-line/components/common';
import type { TimelineEvent } from 'types/cms/blocks/Timeline';

import { TimelineCard } from '../TimelineCard';
import { calcTodayPosition } from '../utils';

const { gridPxClamp } = gridConfig;

interface TimelineColumnProps {
  year: number;
  events?: TimelineEvent[];
  numOfEmptyYears: number;
  isLast: boolean;
}

export function TimelineColumn({
  year,
  events,
  numOfEmptyYears,
  isLast,
}: TimelineColumnProps) {
  const todayElWidth = 40;
  const todayPos = calcTodayPosition(year);

  return (
    <Flex flex={1}>
      <Flex pos="relative" flex={1} mr={isLast ? gridPxClamp : undefined}>
        {!!numOfEmptyYears && (
          <Stack
            flexDir="row"
            pos="absolute"
            top={0}
            right={0}
            bottom={0}
            zIndex={0}
            spacing={0}
          >
            {Array.from({ length: numOfEmptyYears }).map((_, i) => (
              <Box
                key={i}
                flex={1}
                w="sm"
                borderLeft="1px solid"
                borderColor="blackAlpha.250"
              />
            ))}
          </Stack>
        )}
        <Flex flex={1}>
          <Flex borderLeft="1px solid" borderColor="blackAlpha.250" flex={1}>
            <Stack
              ml="3xs"
              mr={isLast ? undefined : '3xs'}
              pos="relative"
              flex={1}
            >
              {events && events.length > 0 && (
                <>
                  <Text as="h5" size="body3">
                    {year}
                  </Text>
                  <Stack spacing="4xs" width="100%" pb="sm">
                    {events.map((event, i) => (
                      <TimelineCard key={i} {...event} />
                    ))}
                  </Stack>
                </>
              )}
              {todayPos !== null && (
                <VStack
                  pos="absolute"
                  top={0}
                  right={`calc(${todayPos} - ${todayElWidth / 2}px)`}
                  bottom={0}
                  alignItems="center"
                  w={`${todayElWidth}px`}
                >
                  <Box h="100%" borderLeft="solid 1px" borderColor="red.300" />
                  <Text
                    color="red.300"
                    size="detail"
                    fontWeight="medium"
                    lineHeight="snug"
                  >
                    Today
                  </Text>
                </VStack>
              )}
            </Stack>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
